import React from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme';

let styles;
const LOGO_ASSET = require('./logo.svg');

const CompanyLogo = props => (
  <div className={css(styles.relative_container, props.styles)}>
    <Link to={props.link}>
      <img src={LOGO_ASSET} alt="The Dog Share Collective" className={css(styles.logo)} />
    </Link>
  </div>
);

CompanyLogo.defaultProps = {
  styles: null,
  link: '/',
};

CompanyLogo.propTypes = {
  styles: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ])),
  link: PropTypes.string,
};

export default CompanyLogo;

styles = StyleSheet.create({
  relative_container: {
    position: 'relative',
  },
  logo: {
    height: 140,
    width: 140,

    [Theme.mobile_query]: {
      position: 'relative',
      top: 0,
      left: 20,
      height: 80,
      width: 80,
      marginBottom: 20,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/CompanyLogo/index.js